import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

const Wrapper = styled("div")`
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledIcon = styled("div")({
  width: "5em",
  height: "5em",
  background: "#fafafa",
  borderRadius: "100%",
  padding: "1em"
});

function MaterialPreviewIcon({ Icon }) {
  return (
    <Wrapper>
      <StyledIcon as={Icon} />
    </Wrapper>
  );
}

MaterialPreviewIcon.propTypes = {
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};

export default MaterialPreviewIcon;
